import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { inject, observer } from 'mobx-react';
import * as moment from 'moment-timezone';
import * as React from 'react';
import { withRouter } from 'react-router';
import { Button, Col, Form, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table } from 'reactstrap';
import TenantStore from 'src/Stores/Tenant/TenantStore';
import { TestsStore } from 'src/Stores/Tests/TestsStore';
import { UserStore } from 'src/Stores/User/UserStore';
import { WellsStore } from 'src/Stores/Wells/WellsStore';

@inject('stores')
@observer
class EmailModal extends React.Component {

    public props: any;
    private testsStore: TestsStore;
    private wellsStore: WellsStore;
    private userStore: UserStore;
    private tenantStore: TenantStore;

    public state = {
        sendReports: {
            extStorageSend: false,
            mudReportSend: true,
            productSnapshotSend: false,
            volReportSend: false,
            volSnapshotSend: false,
            wellStorySend: false,
        }
    };
    constructor(props: any) {
        super(props);
        this.testsStore = this.props.stores.TestsStore;
        this.wellsStore = this.props.stores.WellsStore;
        this.userStore = this.props.stores.UserStore;
        this.tenantStore = this.props.stores.TenantStore;
    }

    public componentDidMount() {
        if (!this.testsStore.test) {
            this.testsStore.getTestDetails(this.props.match.params.taskId, this.props.match.params.wellId);
        }

        if (!this.wellsStore.well) {
            this.wellsStore.getWellDetails(this.props.match.params.wellId);
        }

        if (!this.userStore.user) {
            this.userStore.getProfile();
        }
    }

    public submitEmails = (event: any) => {
        event.preventDefault();
        const body: any = {emailList: []};
        const myForm = new FormData(event.target);
        myForm.forEach((value, key) => {
            switch (key) {
                case 'subject':
                    body.subject = value;
                    break;
                case 'comments':
                    body.comments = value;
                    break;
                case 'mudReportSend':
                case 'volReportSend':
                case 'extStorageSend':
                case 'volSnapshotSend':
                case 'wellStorySend':
                case 'productSnapshotSend':                    
                    break;
                default:
                    body.emailList.push(key);
                    break;
            }
        });
        if (this.userStore.user && this.userStore.user.notificationEmail) {
            body.emailList.push(this.userStore.user.notificationEmail);
        }
        this.props.stores.emailMudReportPdfFromServer(
            this.testsStore.test,
            this.wellsStore.well,
            body,
            this.state.sendReports.mudReportSend,
            this.state.sendReports.volReportSend,
            this.state.sendReports.extStorageSend,
            this.state.sendReports.volSnapshotSend,
            this.state.sendReports.wellStorySend,
            this.state.sendReports.productSnapshotSend,
        )
            .then((data: any) => {
                if (data) {
                      this.props.stores.MessageStore.addMessage('Your Selected Reports were successfully sent to the selected email addresses.', 'success');
                }
            })
            .catch((error: any) => console.trace(error));
        this.props.toggleModal();
    }

    private handleSendClick = (event: any) => {
        const sendReports = this.state.sendReports;
        sendReports[event.target.name] = !sendReports[event.target.name];
        this.setState({
            sendReports
        });
    }
    private sendCheckBox = (label: string, name: string) => {
        return (
            <tr>
                <td>
                    {label}
                </td>
                <td style={{textAlign: 'center', verticalAlign: 'middle'}}>
                    <input
                        name={name}
                        type="checkbox"
                        checked={this.state.sendReports[name]}
                        onClick={this.handleSendClick}
                    />
                </td>
            </tr>
        );
    }
    public render() {
        const test = this.testsStore.test;
        const well = this.wellsStore.well;
        const tests = this.testsStore.tests;
        if (test && well && tests) {
            const showWellStory = test.remarks.wellStories.length > 0;
            const displayApiNo = well.apiNumber ? well.apiNumber : '';
            const subjectDef = `Daily Mud Report - API:${displayApiNo} - ${well.wellName} - ${well.operator.operatorName} - ${well.contractor.contractorName} - ${well.rigNumber} - ${moment.unix(test.testDate).tz(well.timeZoneName).format("MMM DD YYYY - h:mm a")}`;
            return (
                <Modal className="modal-lg" isOpen={this.props.modalOpen} fade={false} toggle={this.props.toggleModal} backdrop="static">
                    <ModalHeader toggle={this.props.toggleModal}>Email Mud Report</ModalHeader>
                    <ModalBody>
                        <Form id="emailForm" onSubmit={this.submitEmails}>
                        <div className="data-table-component">
                            <Table className="sortableTable">
                                <thead>
                                    <tr>
                                        <th>Email To</th>
                                        <th>Type</th>
                                        <th>Email Address</th>
                                        <th>Send</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { well.contractor &&
                                        well.contractor.groupEmails.map(ge =>
                                        <tr key={ge.id}>
                                            <td>{well.contractor.contractorName}</td>
                                            <td>Contractor</td>
                                            <td>{ge.email}</td>
                                            <td style={{textAlign: 'center', verticalAlign: 'middle'}}>
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={true}
                                                    name={ge.email}
                                                    />
                                            </td>
                                        </tr>
                                        )
                                    }
                                    { well.operator && 
                                        well.operator.groupEmails.map(ge => 
                                        <tr key={ge.id}>
                                            <td>{well.operator.operatorName}</td>
                                            <td>Operator</td>
                                            <td>{ge.email}</td>
                                            <td style={{textAlign: 'center', verticalAlign: 'middle'}}>
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={true}
                                                    name={ge.email}
                                                    />
                                            </td>
                                        </tr> 
                                        )
                                    }
                                    { test.internalEmails && 
                                        test.internalEmails.map(wtge => 
                                            <tr key={wtge.id}>
                                                <td>{this.tenantStore.tenant.tenantCompanyName}</td>
                                                <td>Internal</td>
                                                <td>{wtge.email}</td>
                                                <td style={{textAlign: 'center', verticalAlign: 'middle'}}>
                                                    <input
                                                        type="checkbox"
                                                        defaultChecked={wtge.emailDefaultOn}
                                                        name={wtge.email}
                                                        />
                                                </td>
                                            </tr>
                                        )
                                    }
                                    { test.operatorContacts && test.operatorContacts.map((value, index) => 
                                    value.email && <tr key={'operator' + index}>
                                        <td>{`${value.firstName} ${value.lastName}`}</td>
                                        <td>{well.operator && well.operator.operatorName} Contact</td>
                                        <td>{value.email}</td>
                                        <td style={{textAlign: 'center', verticalAlign: 'middle'}}>
                                            <input
                                                type="checkbox"
                                                defaultChecked={value.emailDefaultOn}
                                                name={value.email}
                                                />
                                        </td>
                                    </tr>)}
                                    { test.contractorContacts && test.contractorContacts.map((value, index) => 
                                    value.email && <tr key={'contractor-' + index}>
                                        <td>{`${value.firstName} ${value.lastName}`}</td>
                                        <td>{well.contractor && well.contractor.contractorName} Contact</td>
                                        <td>{value.email}</td>
                                        <td style={{textAlign: 'center', verticalAlign: 'middle'}}>
                                            <input
                                                type="checkbox"
                                                defaultChecked={value.emailDefaultOn}
                                                name={value.email}
                                                />
                                        </td>
                                    </tr>)}
                                    { test.otherContacts && test.otherContacts.map((value, index) => 
                                        value.email && <tr key={'other' + index}>
                                        <td>{`${value.firstName} ${value.lastName}`}</td>
                                        <td>{value.otherTypeName ? value.otherTypeName : 'Other'} Contact</td>
                                        <td>{value.email}</td>
                                        <td style={{textAlign: 'center', verticalAlign: 'middle'}}>
                                            <input
                                                type="checkbox"
                                                defaultChecked={value.emailDefaultOn}
                                                name={value.email}
                                                />
                                        </td>
                                    </tr>)}
                                </tbody>
                            </Table>
                            <Table>
                                <thead>
                                    <tr>
                                        <th>
                                            Report
                                        </th>
                                        <th style={{textAlign: 'center', verticalAlign: 'middle'}}>
                                            Send
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { this.sendCheckBox('Mud Report', 'mudReportSend')}
                                    { this.sendCheckBox('Volume Accounting Report', 'volReportSend')}
                                    { this.sendCheckBox('External Storage Report', 'extStorageSend')}
                                    { this.sendCheckBox('Volume Accounting Snapshot', 'volSnapshotSend')}
                                    { this.sendCheckBox('Product Inventory Snapshot', 'productSnapshotSend')}
                                    { showWellStory && this.sendCheckBox('Well Story', 'wellStorySend')}
                                </tbody>
                            </Table>
                            <Row>
                                <Col>
                                    <h3>Subject:</h3>
                                    <Input
                                        type="text"
                                        defaultValue={subjectDef}
                                        name="subject"
                                        size={subjectDef.length}
                                        autoComplete="off"
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <h3>Comments:</h3>
                                    <Input
                                        type="textarea"
                                        placeholder="Put any comments here"
                                        name="comments"
                                        autoComplete="off"
                                    />
                                </Col>
                            </Row>
                        </div>
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <Row>
                            <Col>
                                <Button color="primary" type="submit" form="emailForm">Send Emails</Button>
                            </Col>
                        </Row>
                    </ModalFooter>
                </Modal>
            );
        } else {
            return (
                <Modal isOpen={this.props.modalOpen} fade={false} toggle={this.props.toggleModal} style={{'maxWidth': 'fit-content'}}>
                    <FontAwesomeIcon 
                        icon={faSpinner}
                        spin={true}
                        size={"8x"}
                        style={{position: 'fixed', left: '50%', top: '35%'}}
                        />
                </Modal>
            );
        }
    }
}

export default withRouter(EmailModal);


// WEBPACK FOOTER //
// ./src/Components/Reporting/EmailModal.tsx